/* eslint-disable max-classes-per-file */

export abstract class JsonSerializable {
    public abstract toJson(): string;
}

export interface EnumNameAndValue {
    name: string;
    value: number;
}

export class EnumValues {
    public static getNamesAndValues(e: any): EnumNameAndValue[] {
        return this.getNames(e).map(enumName => ({ name: enumName, value: e[enumName] as number }));
    }

    public static getNames(e: any): string[] {
        return this.getObjectValues(e).filter(v => typeof v === 'string') as string[];
    }

    public static getValues(e: any): number[] {
        return this.getObjectValues(e).filter(v => typeof v === 'number') as number[];
    }

    private static getObjectValues(e: any): Array<number | string> {
        return Object.keys(e).map(k => e[k]);
    }
}

export interface SoftDeletable {
    isDeleted: boolean;
}

/* export class LogUtils {
    public static toString(value: MultiLingualString): string {
        return value === undefined ? 'undefined' : (value === null ? 'null' : 'de: ' + value.german
            + '; fr: ' + value.french + '; it: ' + value.italian + '; en: ' + value.english);
    }
} */
